module.exports = __webpack_public_path__ + "static/media/chart-pie-alt.b1eae04c.svg";